import { StoryConfigRevision } from "@/api/story-configs-types";
import { Link } from "@/components/ui/Link";
import { useStoryConfigById } from "@/queries/story-configs/use-story-config-by-id";
import { timestampColumns } from "@/utils/datagrid-utils";
import { Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";

const getColumns: (
  configId: string | undefined,
) => GridColDef<StoryConfigRevision>[] = (configId) => [
  {
    field: "id",
    headerName: "ID",
    width: 120,
    renderCell: (params) => (
      <Link to={`/story-configs/${configId}/revisions/${params.row.revision}`}>
        {params.row.id}
      </Link>
    ),
  },
  {
    field: "revision",
    headerName: "Revision",
    width: 90,
  },
  {
    field: "revisionNote",
    headerName: "Revision Note",
    width: 300,
  },
  ...timestampColumns<StoryConfigRevision>(),
];

export function StoryConfigRevisionList({ id }: { id?: string }) {
  const { data } = useStoryConfigById(id);

  const columns = useMemo(() => getColumns(id), [id]);

  if (!data) {
    return null;
  }

  const revisions = data.revisions.toSorted(
    (r1, r2) => r1.revision - r2.revision,
  );

  return (
    <Stack gap={2}>
      <Typography variant="h6">All Revisions</Typography>
      <DataGrid
        rowHeight={46}
        columnHeaderHeight={46}
        columns={columns}
        rows={revisions}
      />
    </Stack>
  );
}
